import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || '';

function getTokenFromUrl() {
  const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  return params.get('token') || '';
}

export default function SetPasswordPage() {
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [notification, setNotification] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setToken(getTokenFromUrl());
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const rawToken = token.trim();
    const pwd = password.trim();
    const confirm = confirmPassword.trim();
    if (!rawToken) {
      setNotification('Linkki on virheellinen (puuttuva token).');
      return;
    }
    if (!pwd) {
      setNotification('Syötä uusi salasana.');
      return;
    }
    if (pwd !== confirm) {
      setNotification('Salasanat eivät täsmää.');
      return;
    }
    setSubmitting(true);
    setNotification(null);
    fetch(`${API}/api/password-reset/set`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: rawToken, newPassword: pwd }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSuccess(true);
        } else {
          setNotification(data.message || 'Salasanan vaihto epäonnistui.');
        }
      })
      .catch(() => setNotification('Yhteysvirhe. Yritä myöhemmin uudelleen.'))
      .finally(() => setSubmitting(false));
  };

  if (success) {
    return (
      <div className="App-block">
        <h2>Salasana vaihdettu</h2>
        <p>Voit nyt kirjautua sisään uudella salasanalla.</p>
        <p>
          <a href="/">Kirjaudu sisään</a>
        </p>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="App-block">
        <h2>Virheellinen linkki</h2>
        <p>Salasanan vaihtolinkki on virheellinen tai puuttuu.</p>
        <p>
          <a href="/password-reset">Pyydä uusi linkki</a>
        </p>
      </div>
    );
  }

  return (
    <div className="App-block">
      <h2>Aseta uusi salasana</h2>
      <form className="SetPassword-form" onSubmit={handleSubmit}>
        <label htmlFor="set-password-new">
          Uusi salasana
          <input
            id="set-password-new"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            disabled={submitting}
          />
        </label>
        <label htmlFor="set-password-confirm">
          Salasana uudelleen
          <input
            id="set-password-confirm"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            disabled={submitting}
          />
        </label>
        {notification && (
          <p className="SetPassword-notification" role="alert">
            {notification}
          </p>
        )}
        <button type="submit" className="Button" disabled={submitting}>
          {submitting ? 'Vaihdetaan…' : 'Vaihda salasana'}
        </button>
      </form>
    </div>
  );
}
